<template>
  <div>
    <base-header class="pb-6">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
        <!-- <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col> -->
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <div class="card-wrapper">
            <template>
              <card>
                <!-- Card header -->
                <h3 slot="header" class="mb-0">修改密码</h3>

                <!-- Card body -->
                <validation-observer
                  v-slot="{ handleSubmit }"
                  ref="formValidator"
                >
                  <form
                    class="needs-validation"
                    @submit.prevent="handleSubmit(passwordFormSubmit)"
                  >
                    <div class="form-row">
                      <b-col md="4">
                        <base-input
                          label="密码"
                          name="密码"
                          placeholder="请输入密码"
                          success-message="Looks good!"
                          :rules="{ required: true, min: 6 }"
                          prepend-icon="ni ni-lock-circle-open"
                          type="password"
                          v-model="model.password"
                        >
                        </base-input>
                      </b-col>

                      <b-col md="4">
                        <base-input
                          label="重复密码"
                          name="重复密码"
                          placeholder="请再次输入密码"
                          success-message="Looks good!"
                          :rules="{ required: true, min: 6 }"
                          prepend-icon="ni ni-lock-circle-open"
                          type="password"
                          v-model="model.password1"
                        >
                        </base-input>
                      </b-col>
                    </div>
                    <base-button type="primary" native-type="submit"
                      >保存</base-button
                    >
                  </form>
                </validation-observer>
              </card>
            </template>

            <!-- <template>
              <card>
                <h3 slot="header" class="mb-0">配置您的火币API参数</h3>
                <b-row>
                  <b-col lg="8">
                    <p class="mb-0">
                      请填写火币AP的 Access Key和Secret.
                      创建时请勾选读取、交易权限。 请不要勾选提币权限；
                    </p>
                  </b-col>
                </b-row>
                <hr />
                <validation-observer
                  v-slot="{ handleSubmit }"
                  ref="formValidator"
                >
                  <form
                    class="needs-validation"
                    @submit.prevent="handleSubmit(settingFormSubmit)"
                  >
                    <div class="form-row">
                      <b-col md="4">
                        <base-input
                          label="Access Key"
                          name="Access Key"
                          placeholder="Access Key"
                          success-message="Looks good!"
                          rules="required"
                          v-model="model.hbAccessKey"
                        >
                        </base-input>
                      </b-col>

                      <b-col md="4">
                        <base-input
                          label="Access Secret (不修改请留空）"
                          name="Access Secret"
                          placeholder="Access Secret (不修改请留空）"
                          v-model="model.hbSecretKey"
                        >
                        </base-input>
                      </b-col>
                    </div>
                    <base-button type="primary" native-type="submit"
                      >保存</base-button
                    >
                  </form>
                </validation-observer>
              </card>
            </template> -->
<!-- 
            <template>
              <card>
                <h3 slot="header" class="mb-0">配置您的币安API参数</h3>
                <b-row>
                  <b-col lg="8">
                    <p class="mb-0">
                      请填写币安API的 Access Key和Secret.
                      创建时请勾选读取、交易权限。 请不要勾选提币权限；
                    </p>
                  </b-col>
                </b-row>
                <hr />
                <validation-observer
                  v-slot="{ handleSubmit }"
                  ref="formValidator"
                >
                  <form
                    class="needs-validation"
                    @submit.prevent="handleSubmit(settingFormSubmitBA)"
                  >
                    <div class="form-row">
                      <b-col md="4">
                        <base-input
                          label="Access Key"
                          name="Access Key"
                          placeholder="Access Key"
                          success-message="Looks good!"
                          rules="required"
                          v-model="model.baAccessKey"
                        >
                        </base-input>
                      </b-col>

                      <b-col md="4">
                        <base-input
                          label="Access Secret (不修改请留空）"
                          name="Access Secret"
                          placeholder="Access Secret (不修改请留空）"
                          v-model="model.baSecretKey"
                        >
                        </base-input>
                      </b-col>
                    </div>
                    <base-button type="primary" native-type="submit"
                      >保存</base-button
                    >
                  </form>
                </validation-observer>
              </card>
            </template> -->
          </div></b-col
        ></b-row
      ></b-container
    >
  </div>
</template>


<script>
import accountApi from "../../api/account";
import swal from "sweetalert2";

export default {
  name: "form-components",
  components: {},
  data() {
    return {
      validated: false,
      model: {
        password: "",
        password1: "",
        hbAccessKey: "",
        hbSecretKey: "",
        baAccessKey: "",
        baSecretKey: "",
      },
    };
  },
  methods: {
    async passwordFormSubmit() {
      // Form submit here
      if (this.model.password == "" || this.model.password.trim() == "") {
        swal
          .fire({
            title: `密码不能为空`,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            confirmButtonText: "确定",
          })
          .then(function () {});
        return;
      }

      if (this.model.password != this.model.password1) {
        swal
          .fire({
            title: `两次输入密码不一致`,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            confirmButtonText: "确定",
          })
          .then(function () {});
        return;
      }

      const data = await accountApi.setPassword({
        password: this.model.password,
      });

      if (data.code == 200) {
        this.model.password = "";
        this.model.password1 = "";

        swal
          .fire({
            title: `修改密码成功！`,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            confirmButtonText: "确定",
          })
          .then(function () {});
      } else {
        const { err_msg } = data;
        swal
          .fire({
            title: err_msg || `修改密码失败！`,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            confirmButtonText: "确定",
          })
          .then(function () {});
      }
    },
    async settingFormSubmit() {
      // Form submit here

      const data = await accountApi.setHBAccessKey({
        hbAccessKey: this.model.hbAccessKey,
        hbSecretKey: this.model.hbSecretKey,
      });

      if (data.code == 200) {
        this.getAccessKey();

        swal
          .fire({
            title: `修改成功！`,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            confirmButtonText: "确定",
          })
          .then(function () {});
      } else {
        const { err_msg } = data;
        swal
          .fire({
            title: err_msg || `设置失败！`,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            confirmButtonText: "确定",
          })
          .then(function () {});
      }
    },

    async settingFormSubmitBA() {
      // Form submit here

      const data = await accountApi.setBAAccessKey({
        baAccessKey: this.model.baAccessKey,
        baSecretKey: this.model.baSecretKey,
      });

      if (data.code == 200) {
        this.getAccessKey();

        swal
          .fire({
            title: `修改成功！`,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            confirmButtonText: "确定",
          })
          .then(function () {});
      } else {
        const { err_msg } = data;
        swal
          .fire({
            title: err_msg || `设置失败！`,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            confirmButtonText: "确定",
          })
          .then(function () {});
      }
    },
    async getAccessKey() {
      const res = await accountApi.getAccessKey();
      if (res.code == 200) {
        const { data } = res;
        this.model.hbAccessKey = data.hb_access_key;
        this.model.hbSecretKey = "";
        this.model.baAccessKey = data.ba_access_key;
        this.model.baSecretKey = "";
      }
    },
  },
  mounted() {
    this.getAccessKey();
  },
};
</script>
